
import React, { Component } from "react";
import * as AppLabels from "../../helper/AppLabels";
import { Utilities, _Map } from '../../Utilities/Utilities';
import { MomentDateComponent } from "./CustomComponents";
import Images from "../../components/images";
// var currency_code = Utilities.getMasterData().currency_code;
export default class TransactionList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            transList: this.props.transactionHistoryList,
            ExpandedIndex: -1,
            selectedTAB: this.props.selectedTAB,
            currency_code: Utilities.getMasterData().currency_code,
            dummyData: [
                { "prize_type": "1", "amount": "14" },
                { "prize_type": "0", "amount": "10" },
                { "prize_type": "2", "amount": "15" }
            ]
        }
    }

    componentDidMount() {
        Utilities.handleAppBackManage('TransactionList')
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.state.transList != nextProps.transactionHistoryList) {
            this.setState({
                transList: nextProps.transactionHistoryList,
                selectedTAB: nextProps.selectedTAB
            })
        }
    }

    expand(idx) {
        this.setState({
            ExpandedIndex: idx
        })
    }
    getAmtFormat = (item) => {
        let points = parseFloat(item.points);
        let real = parseFloat(item.real_amount);
        let winning = parseFloat(item.winning_amount);
        let bonus = parseFloat(item.bonus_amount);
        let currency_code = this.state.currency_code;
        if (this.state.selectedTAB == AppLabels.BONUS) {
            return <i className="icon-bonus"></i>
        }

        return (real > 0 ? currency_code : points > 0 ? <img src={Images.IC_COIN} alt="" style={{ maxWidth: 14 }} /> : winning > 0 ? currency_code : bonus > 0 ? <i className="icon-bonus"></i> : '');
    }
    calcAmt = (item) => {
        let points = parseFloat(item.points);
        var real = parseFloat(item.real_amount);
        let winning = parseFloat(item.winning_amount);
        let bonus = parseFloat(item.bonus_amount);
        if (this.state.selectedTAB == AppLabels.BONUS) {
            return bonus
        }
        if (this.state.selectedTAB == AppLabels.ALL) {
            real = real + winning + bonus;
        }

        return (real > 0 ? real : points > 0 ? points : winning > 0 ? winning : bonus > 0 ? bonus : '0');
    }


    getTransactionStatus(item) {
        if (item.status == 1) {
            return '';
        }
        else if (item.status == 0) {
            return ' (' + AppLabels.TRANSACTION_STATUS_PENDING + ')';
        }
        else if (item.source == "8" && item.status == 2) {
            return ' (' + AppLabels.TRANSACTION_STATUS_REJECTED + ')';
        }
        else {
            return ' (' + AppLabels.TRANSACTION_STATUS_FAILED + ')';
        }
    }

    parseMerchandiseData = (prizeItem, item, idx) => {
        let pAmt = prizeItem.amount;
        let currency_code = this.state.currency_code;
        return (
            (prizeItem.prize_type == 0) ?
                <div className="no-margin" >
                    {item.status == 1 ? <i className="icon-plus text-success"></i> : <i className="icon-info-down warning"></i>}
                    {<i style={{ display: 'inlineBlock', color: "#0CBFEB" }} className="icon-bonus"></i>}
                    {item.custom_data.length === idx + 1 ? Number(parseFloat(pAmt || 0).toFixed(2)) : Number(parseFloat(pAmt || 0).toFixed(2)) + "/"}
                </div>
                :
                (prizeItem.prize_type == 1) ?
                    <div className="no-margin" >
                        {item.status == 1 ? <i className="icon-plus text-success"></i> : <i className="icon-info-down warning"></i>}
                        {<span style={{ display: 'inlineBlock', color: "#0CBFEB" }}>{currency_code}</span>}
                        {item.custom_data.length === idx + 1 ? Number(parseFloat(pAmt || 0).toFixed(2)) : Number(parseFloat(pAmt || 0).toFixed(2)) + "/"}
                    </div>
                    :
                    (prizeItem.prize_type == 2) ?
                        <div className="no-margin">
                            {item.status == 1 ? <i className="icon-plus text-success"></i> : <i className="icon-info-down warning"></i>}
                            <img src={Images.IC_COIN} alt="" style={{ maxWidth: 14 }} />
                            {item.custom_data.length === idx + 1 ? pAmt : pAmt + "/"}
                        </div>
                        :
                        (prizeItem.prize_type == 3) ?
                            <div className="no-margin">
                                {item.custom_data.length === idx + 1 ? prizeItem.name : prizeItem.name + "/"}
                            </div> : ''
        )
    }

    showTransDesc = (item) => {
        let desc = item.trans_desc;
        if (desc && desc.includes('match_date') && item.season_scheduled_date) {
            let startDate = Utilities.getUtcToLocal(item.season_scheduled_date);
            let date = Utilities.getFormatedDateTime(startDate, "MMM DD, YY - hh:mm a");
            desc = desc.replace("{{match_date}}", date);
        }
        if(desc.includes('{{p_to_id}}')){
            desc = desc.replace('{{p_to_id}}',AppLabels.replace_PANTOID(AppLabels.PAN))
        }
        return desc;
    }

    render() {
        const { transList,currency_code } = this.state;
        return (
            <div className="transaction-list">
                <div className="trans-wrap">
                    <div className="trans-header-wrap">
                        <div className="trans-head"></div>
                        <div className="trans-head">
                            <span>
                                <i className="icon-remove"></i>
                            </span>
                        </div>
                        <div className="trans-head">
                            <span>
                                <i className="icon-plus"></i>
                            </span>
                        </div>
                    </div>
                    <div className="trans-body-wrap">
                        {transList.map((item, idx) => {
                            return (
                                <div key={item + idx} className={"trans-tr-wrap " + (this.state.ExpandedIndex === idx ? 'trans-detail-wrap' : '')} onClick={() => this.expand(idx)}>
                                    <div className="trans-tr-view">
                                        <div className="trans-td-view v-mid">
                                            <div className="trans-heading">
                                                {this.showTransDesc(item)}
                                                {this.getTransactionStatus(item)}
                                            </div>
                                            <div className="trans-timing">
                                                <MomentDateComponent data={{ date: item.date_added, format: "MMM DD - hh:mm A " }} />
                                            </div>
                                        </div>
                                        <div className="trans-td-view v-mid">
                                            {item.type == 1 &&
                                                (
                                                    (this.state.ExpandedIndex !== idx || this.state.selectedTAB != AppLabels.ALL) ?
                                                        (
                                                            <div>
                                                                <i className="icon-remove text-danger"></i>
                                                                <span className="color-symbol">{this.getAmtFormat(item)}</span>
                                                                {this.calcAmt(item)}
                                                            </div>
                                                        )
                                                        :
                                                        <React.Fragment>
                                                            {
                                                                item.real_amount > 0 && <div>
                                                                    <i className="icon-remove text-danger"></i>
                                                                    <span>{currency_code}</span>
                                                                    {item.real_amount}
                                                                </div>
                                                            }
                                                            {
                                                                item.bonus_amount > 0 && <div>
                                                                    <i className="icon-remove text-danger"></i>
                                                                    <span className="no-margin-r"><i className="icon-bonus" /></span>{item.bonus_amount}
                                                                </div>
                                                            }
                                                            {
                                                                item.winning_amount > 0 && <div>
                                                                    <i className="icon-remove text-danger"></i>
                                                                    <span>{currency_code}</span>
                                                                    {item.winning_amount}<span>({AppLabels.WIN})</span>
                                                                </div>
                                                            }
                                                            {
                                                                item.points > 0 && <div>
                                                                    <i className="icon-remove text-danger"></i>
                                                                    <img src={Images.IC_COIN} alt="" style={{ maxWidth: 14 }} />
                                                                    {item.points}
                                                                </div>
                                                            }
                                                        </React.Fragment>
                                                )
                                            }
                                        </div>
                                        <div className="trans-td-view v-mid">
                                            {item.type == 0 &&
                                                (
                                                    (this.state.ExpandedIndex !== idx || this.state.selectedTAB != AppLabels.ALL) ?
                                                        (
                                                            <div>
                                                                {
                                                                    item.source != 3  && item.source != 225 && item.source != 226 && item.source != 227 && item.source != 230 && item.source != 322 && item.source != 261 && item.source != 262 && item.source != 263 && item.source != 241
                                                                        ?
                                                                        <React.Fragment>
                                                                            {item.status == 1 ?
                                                                                <i className="icon-plus text-success"></i>
                                                                                :
                                                                                <i className="icon-info-down warning"></i>
                                                                            }
                                                                            <span className="no-margin-l color-symbol">{this.getAmtFormat(item)}</span>
                                                                            {this.calcAmt(item)}
                                                                        </React.Fragment>
                                                                        :
                                                                        item.custom_data ?
                                                                            _Map(item.custom_data, (prizeItem, idx) => {
                                                                                return this.parseMerchandiseData(prizeItem, item, idx)
                                                                            })
                                                                            :
                                                                            <React.Fragment>
                                                                                {
                                                                                    item.real_amount > 0 && <div>
                                                                                        {item.status == 1 ? <i className="icon-plus text-success"></i> : <i className="icon-info-down warning"></i>}
                                                                                        <span>{currency_code}</span>
                                                                                        {item.real_amount}
                                                                                    </div>
                                                                                }
                                                                                {
                                                                                    item.bonus_amount > 0 && <div>
                                                                                        {item.status == 1 ? <i className="icon-plus text-success"></i> : <i className="icon-info-down warning"></i>}
                                                                                        <span className="no-margin-r"><i className="icon-bonus" /></span>{item.bonus_amount}
                                                                                    </div>
                                                                                }
                                                                                {
                                                                                    item.winning_amount > 0 && <div>
                                                                                        {item.status == 1 ? <i className="icon-plus text-success"></i> : <i className="icon-info-down warning"></i>}
                                                                                        <span>{currency_code}</span>
                                                                                        {item.winning_amount}<span>({AppLabels.WIN})</span>
                                                                                    </div>
                                                                                }
                                                                                {
                                                                                    item.points > 0 && <div>
                                                                                        {item.status == 1 ? <i className="icon-plus text-success"></i> : <i className="icon-info-down warning"></i>}
                                                                                        <img src={Images.IC_COIN} alt="" style={{ maxWidth: 14, marginRight: 3 }} />
                                                                                        {item.points}
                                                                                    </div>
                                                                                }
                                                                            </React.Fragment>
                                                                }
                                                            </div>
                                                        )
                                                        :
                                                        <React.Fragment>
                                                            {
                                                                item.source != 3 && item.source != 225 && item.source != 226 && item.source != 227 && item.source != 230 && item.source != 322 && item.source != 261 && item.source != 262 && item.source != 263 && item.source != 241
                                                                    ?
                                                                    <React.Fragment>

                                                                        {
                                                                            item.real_amount > 0 && <div>
                                                                                {item.status == 1 ? <i className="icon-plus text-success"></i> : <i className="icon-info-down warning"></i>}
                                                                                <span>{currency_code}</span>
                                                                                {item.real_amount}
                                                                            </div>
                                                                        }
                                                                        {
                                                                            item.bonus_amount > 0 && <div>
                                                                                {item.status == 1 ? <i className="icon-plus text-success"></i> : <i className="icon-info-down warning"></i>}
                                                                                <span className="no-margin-r"><i className="icon-bonus" /></span>{item.bonus_amount}
                                                                            </div>
                                                                        }
                                                                        {
                                                                            item.winning_amount > 0 && <div>
                                                                                {item.status == 1 ? <i className="icon-plus text-success"></i> : <i className="icon-info-down warning"></i>}
                                                                                <span>{currency_code}</span>
                                                                                {item.winning_amount}<span>({AppLabels.WIN})</span>
                                                                            </div>
                                                                        }
                                                                        {
                                                                            item.points > 0 && <div>
                                                                                {item.status == 1 ? <i className="icon-plus text-success"></i> : <i className="icon-info-down warning"></i>}
                                                                                <img src={Images.IC_COIN} alt="" style={{ maxWidth: 14, marginRight: 3 }} />
                                                                                {item.points}
                                                                            </div>
                                                                        }
                                                                    </React.Fragment>
                                                                    :

                                                                    item.custom_data ?
                                                                        _Map(item.custom_data, (prizeItem, idx) => {
                                                                            return this.parseMerchandiseData(prizeItem, item, idx)
                                                                        })
                                                                        :
                                                                        <React.Fragment>
                                                                            {
                                                                                item.real_amount > 0 && <div>
                                                                                    {item.status == 1 ? <i className="icon-plus text-success"></i> : <i className="icon-info-down warning"></i>}
                                                                                    <span>{currency_code}</span>
                                                                                    {item.real_amount}
                                                                                </div>
                                                                            }
                                                                            {
                                                                                item.bonus_amount > 0 && <div>
                                                                                    {item.status == 1 ? <i className="icon-plus text-success"></i> : <i className="icon-info-down warning"></i>}
                                                                                    <span className="no-margin-r"><i className="icon-bonus" /></span>{item.bonus_amount}
                                                                                </div>
                                                                            }
                                                                            {
                                                                                item.winning_amount > 0 && <div>
                                                                                    {item.status == 1 ? <i className="icon-plus text-success"></i> : <i className="icon-info-down warning"></i>}
                                                                                    <span>{currency_code}</span>
                                                                                    {item.winning_amount}<span>({AppLabels.WIN})</span>
                                                                                </div>
                                                                            }
                                                                            {
                                                                                item.points > 0 && <div>
                                                                                    {item.status == 1 ? <i className="icon-plus text-success"></i> : <i className="icon-info-down warning"></i>}
                                                                                    <img src={Images.IC_COIN} alt="" style={{ maxWidth: 14, marginRight: 3 }} />
                                                                                    {item.points}
                                                                                </div>
                                                                            }
                                                                        </React.Fragment>
                                                            }
                                                        </React.Fragment>
                                                )
                                            }
                                        </div>
                                    </div>
                                    <div className="trans-detail">
                                        <div>
                                            {AppLabels.TRANS_ID}
                                            <span>
                                                {item.order_unique_id}
                                            </span>
                                        </div>
                                        <div>
                                            {AppLabels.STATUS}
                                            <span className="text-success">
                                                {item.status == "0" ? AppLabels.TRANSACTION_STATUS_PENDING
                                                    :
                                                    item.source == "8" && item.status == "2" ? AppLabels.TRANSACTION_STATUS_REJECTED
                                                        :
                                                        item.status == "1" ? AppLabels.TRANSACTION_STATUS_SUCCESS : AppLabels.TRANSACTION_STATUS_FAILED
                                                }
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                        }
                    </div>
                </div>
            </div>
        )
    }
}